import React from 'react'

import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import ErrorIcon from '@material-ui/icons/Error'

import FieldFile from '../../@react-fefmwk/form/modules/FieldFile'
import Table from '../../@react-fefmwk/tables/modules/Table'
import { tableSchema } from '../../services/EntityTableSchema'
import { actionSchema } from '../../services/EntityRowActionsSchema'
import {
    practicals_outers_get_files,
    practicals_outers_upload_files
} from '../../services/BE'

class WidgetPracticalOuterFiles extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            entity: "files",
            id_field: "file",
            path: this.props.path,
            id_practical_outer: this.props.id_practical_outer,
            files: [],
            test: 0,
            refresh: false,
        }
    }
    
    async componentDidMount() {
        const id_practical_outer = this.state.id_practical_outer
        this.setState({
            files: await practicals_outers_get_files( id_practical_outer ),
        })
    }

    render() {
        const entity = this.state.entity
        const id_field = this.state.id_field
        const id_practical_outer = this.state.id_practical_outer
        const files = this.state.files
        const refresh = this.state.refresh
        const fieldsProps = tableSchema(entity)

        const Actions = this.props.hasOwnProperty('Actions')
            ? this.props.Actions
            : true
        const rowActions = Actions
            ? actionSchema(entity)
            : {}

        return <React.Fragment>
            <FieldFile
                name="files[]"
                webkitdirectory={false}
                fileList
                fileListStyle={{}}
                chooseButtonText={"Scegli file"}
                upload_f={async (formFiles) => {
                    const upload = await practicals_outers_upload_files(id_practical_outer,formFiles)
                    if( upload ) {
                        this.setState({
                            refresh: true
                        })
                        this.setState({
                            files: await practicals_outers_get_files( id_practical_outer ),
                            refresh: false
                        })
                    }
                    return upload
                }}
            />
            <br />
            <br />
            {!files.length
                ? <Chip icon={<ErrorIcon />} label="Nessun file trovato" variant="outlined" />
                : <Paper>
                    {!refresh
                        ? <Table material highlight
                            data={files}
                            fieldsProps={fieldsProps}
                            rowActions={rowActions}
                            rowActionsField={id_field}
                            showPagination={true}
                            filterable={true}
                            sortable={true}
                        />
                    : null}
                </Paper>}
        </React.Fragment>
    }
}

export default WidgetPracticalOuterFiles